import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { ACTIVITIES } from '../../data/staticContent';

const FoundationActivities = () => {
  const { t } = useLanguage();

  return (
    <section className="section-pad">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="section-title">{t('activities.title')}</h2>
          <div className="divider-brand-center"></div>
          <p className="section-subtitle">{t('activities.subtitle')}</p>
        </div>

        <div className="row g-4">
          {ACTIVITIES.map(({ key, icon, iconClass }, i) => (
            <div className="col-lg-4 col-md-6" key={key}>
              <div className={`cf-card anim-fade-up anim-delay-${i + 1}`}>
                <div className={`card-icon-wrap ${iconClass}`}>
                  <i className={`bi ${icon}`}></i>
                </div>
                <div className="cf-card-title">{t(`activities.${key}Title`)}</div>
                <p className="cf-card-text">{t(`activities.${key}Desc`)}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Quote banner */}
        <div className="quote-section rounded-4 mt-5 p-5">
          <div className="text-center position-relative" style={{zIndex:1}}>
            <blockquote className="quote-text">{t('activities.quoteActivity')}</blockquote>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FoundationActivities;
